/* eslint-disable func-names */
import { Message } from 'element-ui'
import { isObject, isVNode } from '@utils/is'

let messageInstance = null

const AkeMessage = function (options) {
  if (messageInstance && messageInstance.close) {
    messageInstance.close()
  }
  messageInstance = Message({
    ...options,
    offset: 200,
  })
  return messageInstance
}

;['success', 'warning', 'info', 'error'].forEach((type) => {
  AkeMessage[type] = (options) => {
    if (isObject(options) && !isVNode(options)) {
      return AkeMessage({
        ...options,
        type,
      })
    }
    return AkeMessage({
      type,
      message: options,
    })
  }
})

AkeMessage.close = Message.close
AkeMessage.closeAll = Message.closeAll

export default AkeMessage
